import React, {Component} from "react";
import PropTypes from 'prop-types';

class Loader extends Component {
  render () {
    let {
      loading
    } = this.props;

    let loadingStyle = {
      position: "absolute",
      content: "",
      top: "0",
      left: "0",
      background: "rgba(255,255,255,.8)",
      width: "100%",
      height: "100%",
      zIndex: "100"
    };

    if (!loading) {
      loadingStyle = { display: "none" }
    }

    return (
      <div
        style={loadingStyle}>
        <i
          className="fa fa-spinner fa-spin fa-4x"
          style={{
            top: "50%",
            left: "50%",
            position: "absolute"
          }}
          />
      </div>
    );
  }
}

Loader.propTypes = {
  loading: PropTypes.bool
}

Loader.defaultProps = {
  loading: true
}

export default Loader;



// WEBPACK FOOTER //
// ./components/Loader.js